<form *ngIf="stepForm"
      id="step-form"
      [formGroup]="stepForm">
    <div class="request-container-4 request-content4-scrollable aa-scrollable-y aa-scrollbar"
         *ngIf="catalogEntryQuestions?.length > 0">
        <div class="request-content">
            <div class="question"
                 *ngFor="let question of catalogEntryQuestions">
                <ng-container *ngIf="question.hasEndpoint">
                    <ng-container [ngSwitch]="question.endpointGuid">
                        <aa-input-servers *ngSwitchCase="its2EndpointGuid.Server"
                                          [required]="question.required ? 'required' : undefined"
                                          label="{{ question.label[currentLang] }}"
                                          [name]="question.name"
                                          [formControlName]="question.name">
                        </aa-input-servers>
                        <aa-input-policies *ngSwitchCase="its2EndpointGuid.Policy"
                                           [required]="question.required ? 'required' : undefined"
                                           label="{{ question.label[currentLang] }}"
                                           [name]="question.name"
                                           [formControlName]="question.name">
                        </aa-input-policies>
                    </ng-container>
                </ng-container>
                <ng-container *ngIf="!question.hasEndpoint">
                    <ng-container [ngSwitch]="question.type">
                        <aa-input-its2-list *ngSwitchCase="'list'"
                                            [question]="question"
                                            [required]="question.required ? 'required' : undefined"
                                            label="{{ question.label[currentLang] }}"
                                            [name]="question.name"
                                            [formControlName]="question.name">
                        </aa-input-its2-list>
                        <aa-input-editor *ngSwitchCase="'editor'"
                                         [required]="question.required ? 'required' : undefined"
                                         label="{{ question.label[currentLang] }}"
                                         [name]="question.name"
                                         [formControlName]="question.name">
                        </aa-input-editor>
                        <aa-input-text2 *ngSwitchCase="'text'"
                                        [required]="question.required ? 'required' : undefined"
                                        label="{{ question.label[currentLang] }}"
                                        [name]="question.name"
                                        [formControlName]="question.name">
                        </aa-input-text2>
                        <aa-input-email2 *ngSwitchCase="'email'"
                                         [required]="question.required ? 'required' : undefined"
                                         name="{{ question.name }}"
                                         label="{{ question.label[currentLang] }}"
                                         formControlName="{{ question.name }}">
                        </aa-input-email2>
                        <aa-input-password2 *ngSwitchCase="'password'"
                                            [required]="question.required ? 'required' : undefined"
                                            name="{{ question.name }}"
                                            label="{{ question.label[currentLang] }}"
                                            formControlName="{{ question.name }}">
                        </aa-input-password2>
                        <aa-input-number2 *ngSwitchCase="'number'"
                                          [required]="question.required ? 'required' : undefined"
                                          name="{{ question.name }}"
                                          label="{{ question.label[currentLang] }}"
                                          formControlName="{{ question.name }}">
                        </aa-input-number2>
                        <aa-input-date2 *ngSwitchCase="'date'"
                                        [required]="question.required ? 'required' : undefined"
                                        name="{{ question.name }}"
                                        label="{{ question.label[currentLang] }}"
                                        formControlName="{{ question.name }}">
                        </aa-input-date2>
                        <aa-radio-group3 *ngSwitchCase="'radio'"
                                         [required]="question.required ? 'required' : undefined"
                                         name="{{ question.name }}"
                                         label="{{ question.label[currentLang] }}"
                                         formControlName="{{ question.name }}"
                                         [orientation]="'horizontal'"
                                         [options]="question.options"
                                         [marginTop]="0">
                        </aa-radio-group3>
                        <span *ngSwitchCase="'comment'" [innerHtml]="question.label[currentLang]"></span>
                    </ng-container>
                </ng-container>
            </div>
        </div>

    </div>
</form>
